import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import UnitList from './UnitList';




const UnitPanel = () => {

    return (
    <Row>
        <Col className='text-center'>
            <h1>Enheder</h1>
            <UnitList />


        </Col>
    </Row>
    );

}

export default UnitPanel;